module.exports = __webpack_public_path__ + "03_very_short_yellow.174f3fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_very_short_yellow.png
// module id = lfaV
// module chunks = 0